<template>
    <v-dialog v-model="dialog2" width="80%" height="80%" @input="v => v || closeDialog()">
      <v-layout column class="text-xs-center"
      >

        <v-card>
          <v-card-text>
            <v-btn
              v-show="!isAir"
              class="text-capitalize"
              color="secondary"
              dark
              @click="goTracking('marineTraffic', mmsi)"
            >MarineTraffic</v-btn>
            <v-btn
              v-show="!isAir"
              class="text-capitalize"
              color="secondary"
              dark
              @click="goTracking('myShipTracking', mmsi)"
            >MyShipTracking</v-btn>
            <v-btn
              v-show="isAir"
              class="text-capitalize"
              color="secondary"
              dark
              @click="goTracking('radarBox', sanm)"
            >AirNav-RadarBox</v-btn>
            <v-btn
              v-show="isAir"
              class="text-capitalize"
              color="secondary"
              dark
              @click="goTracking('flightRadar', sanm)"
            >FlightRadar24</v-btn>
            <v-btn
              v-show="isAir"
              class="text-capitalize"
              color="secondary"
              dark
              @click="goTracking('flightAware', sanm)"
            >FlightAware</v-btn>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-dialog>
</template>
<script>
export default {
  data () {
    return {
      dialog2: true,
      sanm: null,
      isAir: true,
      mmsi: null
    }
  },
  methods: {
    closeDialog: function () {
      this.$router.history.go(-1)
      this.dialog2 = false
    },

    goTracking: function (target, name) {
      if (target === 'flightAware') {
        window.open('https://flightaware.com/live/flight/' + name, '_blank')
      } else if (target === 'flightRadar') {
        window.open(
          'https://www.flightradar24.com/data/flights/' + name.toLowerCase(),
          '_blank'
        )
      } else if (target === 'radarBox') {
        window.open(
          'https://www.radarbox24.com/data/flights/' + name,
          '_blank'
        )
      } else if (target === 'marineTraffic') {
        window.open(
          'https://www.marinetraffic.com/en/ais/details/ships/mmsi:' + name,
          '_blank'
        )
      } else if (target === 'myShipTracking') {
        window.open(
          'https://www.myshiptracking.com/?mmsi=' + name,
          '_blank'
        )
      }
    }
  },
  created () {
    if (this.$route.params.sanm === undefined) {
      // press F5
      this.closeDialog()
    } else {
      this.sanm = this.$route.params.sanm
      this.isAir = this.$route.params.isAir
      this.mmsi = this.$route.params.mmsi
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/FlightModal.vue